var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3756 13.8654C13.8536 13.8654 14.241 13.478 14.241 13C14.241 12.5221 13.8536 12.1346 13.3756 12.1346C12.8977 12.1346 12.5103 12.5221 12.5103 13C12.5103 13.478 12.8977 13.8654 13.3756 13.8654Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4333 13.8654C19.9112 13.8654 20.2986 13.478 20.2986 13C20.2986 12.5221 19.9112 12.1346 19.4333 12.1346C18.9553 12.1346 18.5679 12.5221 18.5679 13C18.5679 13.478 18.9553 13.8654 19.4333 13.8654Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31802 13.8654C7.79596 13.8654 8.18341 13.478 8.18341 13C8.18341 12.5221 7.79596 12.1346 7.31802 12.1346C6.84008 12.1346 6.45264 12.5221 6.45264 13C6.45264 13.478 6.84008 13.8654 7.31802 13.8654Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.904959104c27353c9ed9609303bffb44.svg";
export { ForwardRef as ReactComponent };